// GENERATED by scripts/sync-version.js from package.json. Edit the version in package.json, not here.
export const RADAR_VERSION = "2.18.11";
